<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-md-8">
            <h3 class="mt-1 mb-0" v-if="engagement.stakeholder != null">
              {{ engagement.stakeholder.name }}
            </h3>

            <h5 v-if="engagement.stakeholder != null">
              {{ engagement.stakeholder.category }}
            </h5>

            <h5>
              <span
                class="badge"
                :class="{
                  'badge-success': engagement.status == 'Engaged',
                  'badge-danger': engagement.status == 'Cancelled',
                  'badge-warning': engagement.status == 'Created',
                }"
                >{{ engagement.status }}</span
              >
            </h5>

            <div class="my-3" v-if="userHasPerms(['Manage engagements'])">

                 <span
                v-if="engagement.status == 'Created' && engagement.check_in_at == null"
              
                @click="checkIn"
                class="text-success table-action-icon ml-0 mr-2 border-0"
              >
                Check In
              </span>

                    <span
                v-if="engagement.status == 'Engaged' && engagement.check_in_at != null && engagement.check_out_at == null && engagement.engager_user_id == userId"
            
                @click="checkOut"
                class="text-success table-action-icon ml-0 mr-2 border-0"
              >
                Check Out
              </span>



              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'engagements-edit',
                  params: { id: engagement.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-if="engagement.status == 'Created'"
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(engagement.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-md-4 text-center text-md-right">
            <v-lazy-image
              v-if="engagement.stakeholder && engagement.stakeholder.image"
              :src="engagement.stakeholder.image"
              class="img-fluid maxHeight200 mb-2"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
         
            <table class="table table-sm mt-2">
              <table-row label="Date" :noBorder="true"
                >{{
                  moment(new Date(engagement.engagement_date)).format(
                    "DD MMM YYYY, HH:mm"
                  )
                }}
              </table-row>

              <table-row label="Mode">{{ engagement.mode }} </table-row>

              <table-row label="Outcome"
                >{{ engagement.outcome }}
              </table-row>

              <table-row label="Note"
                ><p class="nl2br">{{ engagement.note }}</p></table-row
              >

            

              <table-row label="Created By" v-if="engagement.creator"
                >{{ engagement.creator.name }}
              </table-row>


              <table-row label="" :noBorder="true"> </table-row>

              <small class="text-warning" v-if="engagement.engager">ENGAGEMENT</small>

              <table-row label="Engager" v-if="engagement.engager"
                >{{ engagement.engager.name }}
              </table-row>


                  <table-row label="Checked In" v-if="engagement.check_in_at"
                >{{  moment(new Date(engagement.check_in_at)).format(
                    "DD MMM YY, HH:mm"
                  )}}
              </table-row>
                  <table-row label="In Location" v-if="engagement.check_in_location"
                >{{ engagement.check_in_location}}
              </table-row>
                  <table-row label="Check Out" v-if="engagement.check_out_at"
                >{{  moment(new Date(engagement.check_out_at)).format(
                    "DD MMM YY, HH:mm"
                  ) }}
              </table-row>
                  <table-row label="Out Location" v-if="engagement.check_out_location"
                >{{ engagement.check_out_location }}
              </table-row>

                  <table-row label="Duration" v-if="engagement.duration"
                >{{ engagement.duration }} Minutes
              </table-row>



              <table-row label="" :noBorder="true"> </table-row>
              <small class="text-warning">STAKEHOLDER</small>

              <table-row
                label="Contact Person"
                v-if="engagement.stakeholder"
                >{{ engagement.stakeholder.contact_person }}
              </table-row>

               <table-row
                label="Current Tier"
                v-if="engagement.stakeholder"
                >{{ engagement.stakeholder.current_tier }}
              </table-row>

               <table-row
                label="Desired Tier"
                v-if="engagement.stakeholder"
                >{{ engagement.stakeholder.desired_tier }}
              </table-row>

              <table-row
                v-if="
                  engagement.stakeholder &&
                  engagement.stakeholder.phone_1 != null
                "
                label="Phone"
                ><a :href="'tel:' + engagement.stakeholder.phone_1">{{
                  engagement.stakeholder.phone_1
                }}</a></table-row
              >

              <table-row
                v-if="
                  engagement.stakeholder &&
                  engagement.stakeholder.email_address != null
                "
                label="Email"
                ><a
                  :href="'mailto:' + engagement.stakeholder.email_address"
                  >{{ engagement.stakeholder.email_address }}</a
                ></table-row
              >

              <table-row
                label="Address"
                v-if="
                  engagement.stakeholder &&
                  engagement.stakeholder.physical_address != null
                "
              >
                <a
                  :href="
                    'https://www.google.com/maps/search/?api=1&query=' +
                    engagement.stakeholder.physical_address
                  "
                  target="new"
                  >{{ engagement.stakeholder.physical_address }}
                </a>
              </table-row>

              <table-row  :noBorder="true" >

                <router-link
                    v-if=" engagement.stakeholder "
                :to="{
                  name: 'stakeholders-show',
                  params: { id: engagement.stakeholder.id },
                }"
                class="btn btn-sm btn-primary"
              >
                  View Stakeholder
                </router-link>

              </table-row>

              <table-row icon="lni-database" :noBorder="true" />

              <table-row label="Id">{{ engagement.id }} </table-row>

              <table-row label="Created"
                >{{
                  moment(new Date(engagement.created_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
              <table-row label="Updated"
                >{{
                  moment(new Date(engagement.updated_at)).format(
                    "DD MMM YYYY, HH:mm:ss"
                  )
                }}
              </table-row>
            </table>
            
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import engagementRepo from "@/api/repos/engagementRepo";
import tableRow from "@/components/common/TableRow";


export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getEngagement();
    this.userId = this.$store.state.user.user.id;
  },

  data() {
    return {
      loading: false,
      engagement: {},
      userId:null
    };
  },

  methods: {
    async getEngagement() {
      try {
        this.loading = true;
        let { data } = await engagementRepo.get(this.id);
        this.engagement = data.engagement;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteEngagement(id) {
      this.isBusy = true;
      try {
        await engagementRepo.delete(id);
        this.$emit("engagementUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete the engagement.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.deleteEngagement(id) : false))
        .catch((error) => console.log(error));
    },
     async checkIn() {
      this.loading = true;
      let lat = null;
      let lng = null;
      let err = null;

      await this.getLocation().then(
        (location) => {
          lat = location.coords.latitude;
          lng = location.coords.longitude;
        },
        (error) => {
          err = "Browser Error: " + error.message;
        }
      );
      
      try {
        await engagementRepo.checkIn(this.id,{
          latitude:lat,
          longitude:lng,
          error:err
        });
        this.$emit("engagementUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async checkOut() {
      this.loading = true;
      let lat = null;
      let lng = null;
      let err = null;

      await this.getLocation().then(
        (location) => {
          lat = location.coords.latitude;
          lng = location.coords.longitude;
        },
        (error) => {
          err = "Browser Error: " + error.message;
        }
      );
      
      try {
        await engagementRepo.checkOut(this.id,{
          latitude:lat,
          longitude:lng,
          error:err
        });
        this.$emit("checkedOut",this.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

     async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          this.$router.push({ path: "no-location" });
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          },
          {
            timeout: 10 * 1000,
          }
        );
      });
    },
  },
 
};
</script>
